import { lazyLoad } from 'utils/loadable';

export const MaterialListPage = lazyLoad(
  () => import('./index'),
  module => module.MaterialListPage,
);
